/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { APPROVALS_PATH } from '@/modules/approvals/route';

// Aba "Solicitações de conta" do legado (router.tsx:719-726): abre o hub com a aba em `?tab=` (U42).
export const Route = createFileRoute('/_app/aprovacoes/gestao-aprovacoes/solicitacoes')({
  beforeLoad: () => {
    throw redirect({ to: APPROVALS_PATH, search: { tab: 'solicitacoes' }, replace: true });
  },
});
